import { Translate, type useTranslation } from "@privacy/translations";
import { Strong } from "../shared/Strong";
import type { StatusColumnNotes } from "../shared/statusColumn";

export const sharedProcessingStatusNote = (t: ReturnType<typeof useTranslation>["t"]): StatusColumnNotes => ({
  width: 300,
  noteFor: row => {
    if (row.awaitingClaim && row.managedBy) return { kind: "awaitingClaim", title: t("SharedProcessing.NotInUseYet") };
    if (row.ownCopy && !row.ownCopy.acknowledgedAt)
      return {
        kind: "ownCopy",
        title: t(`RegistrationGrid.StatusNote.${row.ownCopy.reason}.Title`, { customer: row.ownCopy.byName }),
        label: (
          <Translate
            translationKey={`RegistrationGrid.StatusNote.${row.ownCopy.reason}.Title`}
            values={{ customer: <Strong>{row.ownCopy.byName}</Strong> }}
          />
        ),
      };
    return row.managedBy ? null : undefined;
  },
});
